import { ChevronRight, ClipboardList } from "lucide-react";
import { OF_STATUS, PRIORITY } from "@/lib/status";
import { fmtNum } from "@/lib/format";
import { StatusBadge } from "@/components/common/StatusBadge";
import { EmptyState } from "@/components/common/States";
import { cn } from "@/lib/utils";

export const OfPicker = ({ ofs, onPick }) => {
  if (!ofs.length) return <div className="panel"><EmptyState icon={ClipboardList} title="Aucun ordre de fabrication actif" hint="Demandez au planificateur de créer et planifier un OF (statut prévu, en production ou pause)." /></div>;
  const groups = [["en_production", "En production"], ["pause", "En pause"], ["prevu", "Prévus — à démarrer"]];
  return (
    <div className="space-y-4" data-testid="of-picker">
      {groups.map(([st, title]) => {
        const items = ofs.filter((o) => o.statut === st);
        if (!items.length) return null;
        return (
          <section key={st}>
            <h2 className="panel-title mb-2">{title} ({items.length})</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2">
              {items.map((o) => (
                <button key={o.id} type="button" onClick={() => onPick(o)} data-testid={`of-pick-${o.id}`}
                  className="panel relative text-left p-3 pl-4 hover:border-primary/60 hover:bg-accent/30 transition-colors active:scale-[0.99]">
                  <span className={cn("status-stripe", o.statut_affiche === "arret" ? "bg-red-500" : st === "en_production" ? "bg-emerald-500" : st === "pause" ? "bg-sky-400" : "bg-slate-600")} />
                  <div className="flex items-start justify-between gap-2">
                    <div className="min-w-0">
                      <div className="font-bold text-base truncate">{o.ligne}</div>
                      <div className="font-mono text-xs text-primary">{o.numero}</div>
                    </div>
                    <div className="flex flex-col items-end gap-1 shrink-0">
                      <StatusBadge config={OF_STATUS} code={o.statut_affiche} />
                      {o.priorite && o.priorite !== "normale" && <StatusBadge config={PRIORITY} code={o.priorite} />}
                    </div>
                  </div>
                  <div className="text-sm mt-1.5 truncate">{o.produit}</div>
                  <div className="mt-2 flex items-center gap-2 text-[11px] text-muted-foreground">
                    <span>Quart <b className="text-foreground">{o.quart}</b></span>
                    {o.equipe && <span>· {o.equipe}</span>}
                    <span className="ml-auto font-mono">{fmtNum(o.bonnes, o.unite_decimales)} / {fmtNum(o.quantite_cible, o.unite_decimales)} {o.unite_abr}</span>
                  </div>
                  <div className="mt-1.5 h-1.5 bg-muted rounded-sm overflow-hidden"><div className="h-full bg-primary" style={{ width: `${Math.min(o.avancement_pct || 0, 100)}%` }} /></div>
                  <ChevronRight className="absolute right-2 bottom-2 h-4 w-4 text-muted-foreground/50" />
                </button>
              ))}
            </div>
          </section>
        );
      })}
    </div>
  );
};
